module.exports = __webpack_public_path__ + "static/img/bailuobo.734e3ca1.png";